import { render } from "./FileList.vue?vue&type=template&id=ef50cbc8"
import script from "./FileList.vue?vue&type=script&lang=js"
export * from "./FileList.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_7239acc82b1549feaf711c841a4f224f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__